module.exports = __webpack_public_path__ + "img/Forget password_progress bar2.8a36a53f.png";